(function() {
    var TableFilter = function ($el) {
        this.$el = $el
        this.lastVal = this.$el.val()

        this.$el.on('change', this.updateUrl.bind(this))

        return this
    }

    TableFilter.prototype.ifValueNotChanged = function (event) {
        return this.lastVal == this.$el.val()
    }

    TableFilter.prototype.updateUrl = function (event) {
        if (this.ifValueNotChanged()) {
            return false
        }
        
        var url = new URL(window.location)
        var value = this.$el.val()

        if (value) {
            url.searchParams.set(this.$el.attr('name'), value)
        } else {
            url.searchParams.delete(this.$el.attr('name'))
        }

        url.searchParams.delete('page');
        
        pushUrl(url)
    }

    $('.table-filter').each(function () {
        new TableFilter($(this))
    });

    var reloadPage = function () {
        window.location.reload();                                                                        
    }

    var getUrlState = function(url) {
        state = {
            table: {}
        }

        url.searchParams.forEach(function(value, key) {
            state.table[key] = value
        });

        return state
    }
    
    var pushUrl = function (url) {
        history.pushState(getUrlState(url), '', url.toString());
    }

    var replaceUrl = function (url) {
        history.replaceState(getUrlState(url), '', url.toString());
    }

    var setOrderInUrl = function (event, settings, order) {
        var url = new URL(window.location);

        url.searchParams.set('order_col', order[0].col);
        url.searchParams.set('order', order[0].dir);
        url.searchParams.delete('page');

        pushUrl(url)
    }

    var setPaginationInUrl = function (event, settings) {
        var api = new $.fn.dataTable.Api( settings );
        var url = new URL(window.location);

        url.searchParams.set('page', api.page());

        pushUrl(url)
    }

    var setSearchInUrl = function (event, settings) {
        var api = new $.fn.dataTable.Api( settings );
        var url = new URL(window.location);

        url.searchParams.set('search', api.search());

        url.searchParams.delete('page');

        pushUrl(url)
    }

    var setExpandedRowsInUrl = function(event) {
        event.preventDefault()
        var url = new URL(window.location);
        var value = $(this).data('id');

        if ($(this).data('expanded') == 'true') {
            if(url.searchParams.get('expand').indexOf(',') > -1){
                var old_params = url.searchParams.get('expand').split(',');
                old_params.splice(old_params.indexOf(value.toString()), 1);
                url.searchParams.set('expand', old_params.join(','));
            }
            else{
                url.searchParams.delete('expand');
            }
            $(this).removeData('expanded');
        } else {
            if(url.searchParams.get('expand') !== null){
                if(url.searchParams.get('expand').split(',').indexOf(value.toString()) == -1){
                    url.searchParams.set('expand', url.searchParams.get('expand') + ',' + value);
                }
            }
            else{
                url.searchParams.set('expand', value);
            }
            $(this).data('expanded', 'true');
        }

        replaceUrl(url)
    }

    var setPageLengthInUrl = function (event, settings, len) {
        var url = new URL(window.location);

        url.searchParams.set('page_len', len);

        url.searchParams.delete('page');

        pushUrl(url)
    }

    var setTableSettingsFromUrl = function (event, settings) {
        var api = new $.fn.dataTable.Api(settings);
        var params = new URL(window.location).searchParams
        var pageLength = params.get('page_len') ? params.get('page_len') : 10

        if (params.get('search')) {
            api.search(params.get('search'))
        }

        if (params.get('order_col') && params.get('order')) {
            api.order([
                params.get('order_col'),
                params.get('order')
            ])
        }

        api.page.len(pageLength)
    }

    var initTableFilters = function (event, settings) {
        var api = new $.fn.dataTable.Api(settings)

        api.columns('.filterable')
            .every(createColumnSelectFilter)
    }

   /**
    * Bind after init url. Otherwise additional history 
    * states are created.
    */
    var bindTableUrlListners = function() {
        $(document).on('length.dt', setPageLengthInUrl)
        $(document).on('page.dt', setPaginationInUrl);
        $(document).on('order.dt', setOrderInUrl);
        $(document).on('search.dt', setSearchInUrl);
        $(document).on('click', '.btn-expand-row', setExpandedRowsInUrl);
    }

    $(document).on('preInit.dt', setTableSettingsFromUrl)
    $(document).on('init.dt', initTableFilters)
    $(document).on('init.dt', bindTableUrlListners)
    window.addEventListener('popstate', reloadPage);
})()
